import {HttpClient, RequestParams} from "../../utils/api/http-client";
import IBaseListingResponse from "../../utils/api/base-listing-response";
import {IOrphanQuery} from "../../models/orphan/query";
import {IOrphan, IOrphanDetails} from "../../models/orphan/response";
import {ICreateOrphan, IUpdateOrphan} from "../../models/orphan/request";

class OrphanService<SecurityDataType = unknown> {
    http: HttpClient<SecurityDataType>;

    constructor(http: HttpClient<SecurityDataType>) {
        this.http = http;
    }

    getAllOrphans = (query: IOrphanQuery, params?: RequestParams) =>
        this.http.request<IBaseListingResponse<IOrphan>>({
            path: `/orphans`,
            method: "GET",
            query,
            ...params,
        });

    getOrphan = (id: number, params?: RequestParams) =>
        this.http.request<IOrphanDetails>({
            path: `/orphans/${id}`,
            method: "GET",
            ...params,
        });

    createOrphan = (data: ICreateOrphan, params?: RequestParams) =>
        this.http.request<IOrphan>({
            path: "/orphans",
            method: "POST",
            body: data,
            ...params,
        });

    updateOrphan = (id: number, data: IUpdateOrphan, params?: RequestParams) =>
        this.http.request<IOrphan>({
            path: `/orphans/${id}`,
            method: "PUT",
            body: data,
            ...params,
        });

    deleteOrphan = (id: number, params?: RequestParams) =>
        this.http.request<IOrphan>({
            path: `/orphans/${id}`,
            method: "DELETE",
            ...params,
        });
}

export default OrphanService;